'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _defineProperty = _interopDefault(require('babel-runtime/helpers/defineProperty'));
var _extends = _interopDefault(require('babel-runtime/helpers/extends'));
var reactRedux = require('react-redux');
var userSessionStoreCore = require('@zillow/user-session-store-core');

/**
 * Combines global state (if exists) with local state before passed off to mapStateToProps.
 * @param {Function} selector - mapper of combined state to plain object to be merged into component props
 * @param {String} globalKey - optional namespacing key for global state values
 * @return {Function} mapStateToProps state to object props mapper
 */
function combineUserSessionStateToProps(selector) {
    var globalKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    return function (localState, localOwnProps) {
        if (typeof selector === 'undefined') {
            throw new Error('selector not specified');
        }

        var globalState = userSessionStoreCore.hasUserSessionStore() ? userSessionStoreCore.getUserSessionStore().getState() : {};

        if (globalKey !== '') {
            return selector(_extends({}, localState, _defineProperty({}, globalKey, globalState)), localOwnProps);
        }

        return selector(_extends({}, globalState, localState), localOwnProps);
    };
}

/**
 * UserSession wrapper for redux connect.
 * @param {Function} mapStateToProps - (state, ownProps) => {...} (must return object)
 * @return {Class} higher-order React component class
 */
function connectToUserSession(mapStateToProps, mapDispatchToProps, mergeProps, options) {
    return reactRedux.connect(function (state) {
        return combineUserSessionStateToProps(mapStateToProps)(state);
    }, mapDispatchToProps, mergeProps, _extends({ pure: false }, options) // prevent memoization by default
    );
}

exports.combineUserSessionStateToProps = combineUserSessionStateToProps;
exports.default = connectToUserSession;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@zillow/reg-login/~/@zillow/user-session-store-connect/lib/index.js
// module id = 503
// module chunks = 0